import React from 'react';
import GisIndex from "./gis-index.jsx";

const SentrygridIndex = () => {
    return (
        <>
            <GisIndex sentryGrid={true}/>
        </>
    );
};

export default SentrygridIndex;